// src/LoadingSpinner/LoadingSpinner.tsx
import Box from "@cloudscape-design/components/box";
import Spinner from "@cloudscape-design/components/spinner";
import { useAppTranslation } from "@amzn/awsmp-max-translations";
import { jsx, jsxs } from "react/jsx-runtime";
var LoadingSpinner = ({ size = "large", text, padding = "xxl" }) => {
  const { t } = useAppTranslation();
  const displayText = text ?? t("loading");
  return /* @__PURE__ */ jsxs(Box, { textAlign: "center", padding, children: [
    /* @__PURE__ */ jsx(Spinner, { size }),
    /* @__PURE__ */ jsx(Box, { variant: "p", padding: { top: "s" }, children: displayText })
  ] });
};
export {
  LoadingSpinner
};
//# sourceMappingURL=index.js.map
